import React from 'react';
import MusicNoteIcon from '@mui/icons-material/MusicNote';
import HomeIcon from '@mui/icons-material/Home';
import CodeIcon from '@mui/icons-material/Code';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import SchoolIcon from '@mui/icons-material/School';
import FaceRetouchingNaturalIcon from '@mui/icons-material/FaceRetouchingNatural';
import CheckroomIcon from '@mui/icons-material/Checkroom';
import GraphicEqIcon from '@mui/icons-material/GraphicEq';
import TheaterComedyIcon from '@mui/icons-material/TheaterComedy';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import DeveloperModeIcon from '@mui/icons-material/DeveloperMode';

export const logo = 'https://i.ibb.co/s9Qys2j/logo.png';

export const categories = [
    { name: 'New', icon: <HomeIcon fontSize='5rem' />, },
    { name: 'Music', icon: <MusicNoteIcon fontSize='5rem' /> },
    { name: 'Education', icon: <SchoolIcon fontSize='5rem' />, },
    { name: 'Podcast', icon: <GraphicEqIcon fontSize='5rem' />, },
    { name: 'Movie', icon: <OndemandVideoIcon fontSize='5rem' />, },
    { name: 'Gaming', icon: <SportsEsportsIcon fontSize='5rem' />, },
    { name: 'Live', icon: <LiveTvIcon fontSize='5rem' />, },
    { name: 'Sport', icon: <FitnessCenterIcon fontSize='5rem' />, },
    { name: 'Fashion', icon: <CheckroomIcon fontSize='5rem' />, },
    { name: 'Beauty', icon: <FaceRetouchingNaturalIcon fontSize='5rem' />, },
    { name: 'Comedy', icon: <TheaterComedyIcon fontSize='5rem' />, },
    { name: 'Gym', icon: <FitnessCenterIcon fontSize='5rem' />, },
    { name: 'Crypto', icon: <DeveloperModeIcon fontSize='5rem' />, },
    { name: 'JS Mastery', icon: <CodeIcon fontSize='5rem' />, },
    { name: 'Coding', icon: <CodeIcon fontSize='5rem' />, },
    { name: 'ReactJS', icon: <CodeIcon fontSize='5rem' />, },
    { name: 'NextJS', icon: <CodeIcon fontSize='5rem' />, },
];

export const demoThumbnailUrl = 'https://i.ibb.co/G2L2Gwp/API-Course.png';
export const demoChannelUrl = '/channel/UCmXmlB4-HJytD7wek0Uo97A';
export const demoVideoUrl = '/video/GDa8kZLNhJ4';
export const demoChannelTitle = 'JavaScript Mastery';
export const demoVideoTitle = 'Build and Deploy 5 JavaScript & React API Projects in 10 Hours - Full Course | RapidAPI';
export const demoProfilePicture = 'http://dergipark.org.tr/assets/app/images/buddy_sample.png'